import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TicketListContent from './TicketListContent';
import useStyles from './styles';
import AddTicketPopUp from '../../AddTicketPopUp/AddTicketPopUp';
import { setAddTicket } from '../ContentTabs/ContentTabsSlice';
import {
  currentViewNameState,
  userPreferencesState,
  initializeUserPreferences,
} from './TicketListSlice';
import SettingPopUp from './SettingPopUp/SettingPopUp';
import ExcelExportPopUp from './ExcelExportPopUp/ExcelExportPopUp';
import Tab from '../../AppBarWithTabs/Tab';
import AppBarTicketList from './AppBarTicketList';
import EndAppBarTicketList from './EndAppBarTicketList';
import ApiService from '../../../services/ApiService';

export default function TicketList() {
  const classes = useStyles();
  const { t } = useTranslation();
  const selectedTab = useSelector(currentViewNameState);
  const [openAddTicketPopUp, setOpenAddTicketPopUp] = React.useState(false);
  const [openSetting, setOpenSetting] = React.useState(false);
  const [openExportPopUp, setOpenExportPopUp] = React.useState(false);
  const mountedRef = useRef(true);
  const userPreferences = useSelector(userPreferencesState);
  const [tabs, setTabs] = React.useState(userPreferences);

  useEffect(() => {
    setTabs(userPreferences);
  }, [selectedTab]);

  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  function getAddTicketState(addTicket) {
    if (mountedRef.current) {
      dispatch(setAddTicket(addTicket));
    }
  }
  const handleClickOpen = () => {
    if (mountedRef.current) {
      setOpenAddTicketPopUp(true);
    }
  };
  function handleClose(openState) {
    if (mountedRef.current) {
      setOpenAddTicketPopUp(openState);
    }
  }
  const handleClickOpenSetting = () => {
    if (mountedRef.current) {
      setOpenSetting(true);
    }
  };
  function handleSettingClose(openSettingState) {
    if (mountedRef.current) {
      setOpenSetting(openSettingState);
    }
  }
  function handleExcelExportClose(openExportPopUpState) {
    if (mountedRef.current) {
      setOpenExportPopUp(openExportPopUpState);
    }
  }
  function handleExcelExportOpen() {
    if (mountedRef.current) {
      setOpenExportPopUp(true);
    }
  }

  const formatUserPrefs = (data) => {
    const userPreferencesFormatted = data.map((userPreference) => {
      const pref = {};
      const indexViewName = userPreference.viewName.lastIndexOf(' - ');
      const viewName = userPreference.viewName.slice(0, indexViewName);
      const ticketListFiltered = userPreference.viewName.slice(
        viewName !== 'open tickets' &&
          viewName !== 'closed tickets' &&
          viewName !== 'tickets'
          ? indexViewName + 3
          : indexViewName,
      );
      pref.viewName = viewName;
      pref.ticketListFiltered = ticketListFiltered;
      const { filter, tableSetting } = userPreference;
      pref.filteredColumns = tableSetting;
      pref.rowsFilters = [];
      Object.keys(filter).forEach((key) => {
        const rowsFilter = {};
        rowsFilter.cell = key;
        const translatedSelectedOption = [];
        filter[key].forEach((selectedOption) =>
          translatedSelectedOption.push(t(selectedOption)),
        );
        rowsFilter.selectedOptions = translatedSelectedOption;
        pref.rowsFilters.push(rowsFilter);
      });
      return pref;
    });
    return userPreferencesFormatted;
  };

  const handleClickClearAllFilters = () => {
    if (mountedRef.current) {
      ApiService.getUserPreferences().then((response) => {
        const userPreferencesFormatted = formatUserPrefs(response.data);
        dispatch(initializeUserPreferences(userPreferencesFormatted));
      });
    }
  };

  return (
    <div className={classes.root}>
      <AppBarTicketList>
        <EndAppBarTicketList
          handleClickOpenSetting={handleClickOpenSetting}
          handleClickOpen={handleClickOpen}
          handleClickClearAllFilters={handleClickClearAllFilters}
          handleExcelExport={handleExcelExportOpen}
        />
      </AppBarTicketList>
      {tabs.map((view, index) => {
        const key = `table-key-${index}`;
        return (
          <Tab selectedTab={selectedTab} index={view.viewName} key={key}>
            <TicketListContent
              selectedTicketType={view.ticketListFiltered}
              formatUserPrefs={formatUserPrefs}
            />
          </Tab>
        );
      })}
      <AddTicketPopUp
        open={openAddTicketPopUp}
        setAddTicketState={getAddTicketState}
        setPopUpOpenedState={handleClose}
      />
      <SettingPopUp
        openSetting={openSetting}
        setOpenSettingState={handleSettingClose}
      />
      <ExcelExportPopUp
        openExportPopUp={openExportPopUp}
        setExcelPopUpOpenedState={handleExcelExportClose}
      />
    </div>
  );
}
